import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/jiantou1.png'


const _withScopeId = n => (_pushScopeId("data-v-10433576"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "firms"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"head\" data-v-10433576><div class=\"left\" data-v-10433576><div class=\"written\" data-v-10433576><i class=\"iconfont icon-a-Group14596\" data-v-10433576></i></div><p data-v-10433576>填写企业信息</p></div><img src=\"" + _imports_0 + "\" class=\"icon\" alt=\"\" data-v-10433576><div class=\"right\" data-v-10433576><div class=\"id\" data-v-10433576><i class=\"iconfont icon-zhengjian\" data-v-10433576></i></div><p data-v-10433576>上传相关证件</p></div></div>", 1)
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fa1115"} }, "*", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "公司名称", -1))
const _hoisted_7 = { class: "location" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fa1115"} }, "*", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "公司地址", -1))
const _hoisted_10 = { class: "product" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fa1115"} }, "*", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "主营产品", -1))
const _hoisted_13 = { class: "firmtype" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fa1115"} }, "*", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "公司类型", -1))
const _hoisted_16 = { class: "firmtypes" }
const _hoisted_17 = {
  key: 1,
  class: "firm"
}
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"head\" data-v-10433576><div class=\"left\" data-v-10433576><div class=\"written\" data-v-10433576><i class=\"iconfont icon-a-Group14596\" data-v-10433576></i></div><p data-v-10433576>填写企业信息</p></div><img src=\"" + _imports_0 + "\" class=\"icon\" alt=\"\" data-v-10433576><div class=\"right\" data-v-10433576><div class=\"id\" data-v-10433576><i class=\"iconfont icon-zhengjian\" data-v-10433576></i></div><p data-v-10433576>上传相关证件</p></div></div>", 1)
const _hoisted_19 = { class: "submitform" }
const _hoisted_20 = { class: "idphoto" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fa1115"} }, "*", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "营业执照", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-jiahao1" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "set" }, " 请上传图片,仅支持jpg、png、dgft格式,单张大小不得超过5M ", -1))
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "name" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fa1115"} }, "*", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "联系人姓名", -1))
const _hoisted_29 = { class: "phone" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fa1115"} }, "*", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "联系人电话", -1))
const _hoisted_32 = { class: "firmphone" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fa1115"} }, "*", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "公司电话", -1))
const _hoisted_35 = { class: "button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_elui_china_area_dht = _resolveComponent("elui-china-area-dht")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_el_form, {
            ref: "ruleFormRef",
            model: _ctx.firmForm,
            rules: _ctx.rules,
            class: "demo-ruleForm",
            "status-icon": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _hoisted_6,
                  _createVNode(_component_el_form_item, { prop: "comopany" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.firmForm.comopany,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firmForm.comopany) = $event)),
                        placeholder: "请输入公司名称"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _hoisted_9,
                  _createVNode(_component_el_form_item, {
                    prop: "area",
                    class: "city"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_elui_china_area_dht, {
                          onChange: _ctx.onChange,
                          placeholder: "请选择地区",
                          modelValue: _ctx.companyForm.addr,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companyForm.addr) = $event)),
                          class: "diqu"
                        }, null, 8, ["onChange", "modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { prop: "address" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.firmForm.address,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.firmForm.address) = $event)),
                        placeholder: "请输入详细地址",
                        class: "address"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _hoisted_12,
                  _createVNode(_component_el_form_item, { prop: "products" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.firmForm.products,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.firmForm.products) = $event)),
                        maxlength: "50",
                        placeholder: "请输入主营产品",
                        "show-word-limit": "",
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _hoisted_15,
                  _createVNode(_component_el_form_item, { prop: "company_type" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.firmForm.company_type,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.firmForm.company_type) = $event)),
                          placeholder: "请选择公司类型",
                          class: "el-icon--right"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "有限责任公司",
                              value: "有限责任公司"
                            }),
                            _createVNode(_component_el_option, {
                              label: "股份有限公司",
                              value: "采购/股份有限公司/渠道运营"
                            }),
                            _createVNode(_component_el_option, {
                              label: "个人独资企业",
                              value: "个人独资企业"
                            }),
                            _createVNode(_component_el_option, {
                              label: "个体工商户",
                              value: "个体工商户"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "routine submit",
                      type: "primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef))),
                      plain: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("下一步")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_el_form, {
            ref: "ruleFormRef1",
            model: _ctx.firmForms,
            rules: _ctx.rules1,
            class: "demo-ruleForm",
            "status-icon": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _hoisted_22,
                  _createVNode(_component_el_form_item, { prop: "license" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_upload, {
                        class: _normalizeClass(["avatar-uploader", { nonejiahao: _ctx.firmForms.license.length > 0 }]),
                        "file-list": _ctx.firmForms.license,
                        "onUpdate:fileList": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.firmForms.license) = $event)),
                        action: "",
                        "list-type": "picture-card",
                        "on-preview": _ctx.handlePictureCardPreviews,
                        accept: ".jpg,.png,.dgft",
                        limit: 3,
                        "before-upload": _ctx.beforeUpload
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      }, 8, ["file-list", "on-preview", "before-upload", "class"])
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_24,
                _createVNode(_component_el_dialog, {
                  modelValue: _ctx.dialogVisibles,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialogVisibles) = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      "w-full": "",
                      src: _ctx.dialogImageUrls,
                      alt: "Preview Image",
                      class: "bigimg"
                    }, null, 8, _hoisted_25)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _hoisted_28,
                  _createVNode(_component_el_form_item, { prop: "name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.firmForms.name,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.firmForms.name) = $event)),
                        placeholder: " 请输入姓名"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _hoisted_31,
                  _createVNode(_component_el_form_item, { prop: "mobile" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.firmForms.mobile,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.firmForms.mobile) = $event)),
                        placeholder: " 请输入联系人电话"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _hoisted_34,
                  _createVNode(_component_el_form_item, { prop: "office_num" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.firmForms.office_num,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.firmForms.office_num) = $event)),
                        placeholder: " 请输入公司电话"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  plain: "",
                  class: "button1 routine submit",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.goback && _ctx.goback(...args)))
                }, " 上一步 "),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      class: "routine button2 submit",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.submitForm1(_ctx.ruleFormRef1)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("提交")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}